import { Col, Row } from "antd";
import React from "react";
import { IncidenciasAsignacion } from "./_IncidenciasAsignacion";
import { IncidenciasArribo } from "./_IncidenciasArribo";
import { BotonListadoIncidencias } from "./_BotonListadoIncidencias";
import { useSelector } from "react-redux";
import { BotonEnEsperaUsuario } from "./_BotonEnEsperaUsuario";
import { BotonCobros } from "./_BotonCobros";
import { DatosCobros } from "./_DatosCobros";
import { IncidenciaInterna } from "./_IncidenciaInterna";
import { BotonReembolsos } from "./_BotonReembolsos";
import { BotonQuejaPotencial } from "./_BotonQuejaPotencial";

export const Incidencias = () => {
  const { asistencia } = useSelector((state) => state.detalleReducer);

  return (
    <Row style={{ padding: 15 }} align="bottom" gutter={[16, 8]}>
      {asistencia.estatusID === 2 && asistencia.estatusFinalID === 1 && (
        <Col span={6}>
          <IncidenciasAsignacion />
        </Col>
      )}
      {asistencia.estatusID > 2 && asistencia.estatusFinalID === 1 && (
        <Col span={6}>
          <IncidenciasArribo />
        </Col>
      )}
      {asistencia.estatusFinalID === 1 && (
        <Col span={6}>
          <IncidenciaInterna />
        </Col>
      )}
      {asistencia.estatusID > 1 && asistencia.incidencias.length > 0 && (
      <Col span={6}>
        <BotonListadoIncidencias />
      </Col>
    )}
    <Col>
      <BotonEnEsperaUsuario />
    </Col>
    <Col>
      <BotonQuejaPotencial />
    </Col>
    {asistencia.estatusFinalID > 1 && (
      <>
        <Col><BotonCobros /></Col>
        <Col><BotonReembolsos /></Col>
        <Col><DatosCobros /></Col>
      </>
    )}
    </Row>
  );
};
